import Store from '@/store/computed/storeHelpers'
export default {
  computed: {
    defaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'billDefaultHeaders'
    })
  },
  data() {
    return {
      allPossibleHeaders: [
        {
          text: 'ID',
          align: 'left',
          value: 'id',
          type: 'text',
          show: false
        },
        {
          text: 'Billing Period',
          align: 'left',
          value: 'billingPeriod',
          type: 'text',
          show: false
        },
        {
          text: 'Bill Date',
          align: 'left',
          value: 'date',
          type: 'date',
          show: false
        },
        {
          text: 'Bill Reference',
          align: 'left',
          value: 'externalRef',
          type: 'text',
          show: false
        },
        {
          text: 'Xero Reference',
          align: 'left',
          value: 'xeroRef',
          type: 'text',
          show: false
        },
        {
          text: 'Project',
          align: 'left',
          value: 'project.name',
          type: 'text',
          show: false
        },
        // {
        //   text: 'Site',
        //   align: 'left',
        //   value: 'site.name',
        //   type: 'text',
        //   show: false
        // },
        {
          text: 'ABN',
          align: 'left',
          value: 'abn',
          type: 'text',
          show: false
        },
        {
          text: 'Trips',
          align: 'right',
          value: 'tripCount',
          type: 'text',
          show: false
        },
        {
          text: 'Hours',
          align: 'right',
          value: 'hoursTotal',
          type: 'num',
          decimals: 1,
          show: false
        },
        {
          text: 'Tip Weight',
          align: 'right',
          value: 'siteWeightTotal',
          type: 'num',
          decimals: 0,
          show: false
        },
        {
          text: 'Truck Weight',
          align: 'right',
          value: 'scaleWeightTotal',
          type: 'num',
          decimals: 0,
          show: false
        },
        {
          text: 'Site Weight',
          align: 'right',
          value: 'tipWeightTotal',
          type: 'num',
          decimals: 0,
          show: false
        },
        {
          text: 'Total',
          align: 'right',
          value: 'total',
          type: 'curr',
          decimals: 2,
          show: false
        },
        {
          text: 'Internal notes',
          align: 'left',
          value: 'internalNotes',
          type: 'text',
          show: false
        },
        {
          text: 'Invoice notes',
          align: 'left',
          value: 'invoiceNotes',
          type: 'text',
          show: false
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status',
          type: 'text',
          show: false
        },
        {
          text: 'Type',
          align: 'left',
          value: 'type',
          type: 'text',
          show: false
        },
        {
          text: 'Created By',
          align: 'left',
          value: 'user.name',
          type: 'text',
          show: false
        },
        {
          text: 'Created At',
          align: 'left',
          value: 'createdAt',
          type: 'date',
          show: false
        },
        {
          text: 'Updated At',
          align: 'left',
          value: 'updatedAt',
          type: 'date',
          show: false
        }
      ]
    }
  }
}
